import * as React from "react";
import Flickity from "react-flickity-component";
import { HighlightWrapper, BannerPlaceholder } from "./Styled";
// import { Link } from "react-router-dom";
import Link from '../../Public/Util/Link'
import axios from "axios";
import { BASE_URL, getYouTubeId } from "../Util";
import Modal from "../../Pages/Home/Modal";
import { FaPlay } from "react-icons/fa";

class Highlight extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: []
    };
  }
  callAPI = async () => {
    try {
      await axios
        .get(BASE_URL + "/api/homeBanners")
        // .get(BASE_URL + "/api/products?filter=FEATURED")
        .then(response => {
          const {
            data: {
              response: { homeBanners }
            }
          } = response;

          this.setState({
            page: homeBanners
          });
        });
    } catch (e) {
      console.log(e);
    }
  };
  componentDidMount() {
    this.callAPI();
  }

  openModal = videoUrl => {
    this.setState({
      modalVideoUrl: videoUrl,
      modalIsOpen: true
    });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const { page, modalVideoUrl, modalIsOpen } = this.state;
    const pageLength = page.length || 0;
    return (
      <>
        <HighlightWrapper>
          <div className="wrapper">
            <h1 className="title">Highlight</h1>
          </div>
          <div className="banner-wrapper">
            <Flickity
              className={"flickity"} // default ''
              elementType={"div"} // default 'div'
              options={{
                initialIndex: 0
              }} // takes flickity options {}
              disableImagesLoaded={false} // default false
              reloadOnUpdate // default false
              static // default false
            >
              {page.map((item, index) => {
                const {
                  id,
                  type,
                  title,
                  content,
                  image_arr,
                  video,
                  redirect_url,
                  short_description,
                  tag
                } = item;

                const youtubeVideoId = video && getYouTubeId(video);

                const videoThumbnail = `https://img.youtube.com/vi/${youtubeVideoId}/0.jpg`;
                const image = image_arr && image_arr[0];
                const bannerType =
                  type === "article"
                    ? "media"
                    : type === "product"
                    ? "pasar"
                    : undefined;

                const url =
                  redirect_url && redirect_url.startsWith("http")
                    ? redirect_url
                    : `http://${redirect_url}`;

                const slug =
                  (type === "article" || type === "product") && item[type].slug;

                return (
                  <React.Fragment key={`highlight-banner-${index}`}>
                    {video !== null ? (
                      <div
                        className="banner-item"
                        key={`${index}-banner-video`}
                        onClick={video ? () => this.openModal(video) : null}
                      >
                        <div
                          className="banner-image"
                          style={{
                            backgroundImage: `url(${
                              video ? videoThumbnail : image
                            })`
                          }}
                        >
                          <div className="play-btn">
                            <FaPlay />
                          </div>
                        </div>
                        <div className="banner-title">
                          <h3 className="sub-title">{tag}</h3>
                          <h1 className="title">{title}</h1>
                          <p className="content">{short_description}</p>
                        </div>
                      </div>
                    ) : bannerType ? (
                      <Link
                        to={`/${bannerType}/${slug}`}
                        className="banner-item"
                        key={`${index}-banner-internal`}
                      >
                        <div
                          className="banner-image"
                          style={{
                            backgroundImage: `url(${
                              video ? videoThumbnail : image
                            })`
                          }}
                        />
                        <div className="banner-title">
                          <h3 className="sub-title">{tag}</h3>
                          <h1 className="title">{title}</h1>
                          <p className="content">{short_description}</p>
                        </div>
                      </Link>
                    ) : (
                      <a
                        href={url}
                        target="_blank"
                        className="banner-item"
                        key={`${index}-banner-redirect`}
                      >
                        <div
                          className="banner-image"
                          style={{
                            backgroundImage: `url(${
                              video ? videoThumbnail : image
                            })`
                          }}
                        />
                        <div className="banner-title">
                          <h3 className="sub-title">{tag}</h3>
                          <h1 className="title">{title}</h1>
                          <p className="content">{short_description}</p>
                        </div>
                      </a>
                    )}
                  </React.Fragment>
                );
              })}
            </Flickity>
          </div>
        </HighlightWrapper>
        <Modal
          modalVideoUrl={modalVideoUrl}
          modalIsOpen={modalIsOpen}
          close={this.closeModal}
        />
      </>
    );
  }
}

export default Highlight;
